const headers = [
    { text: 'Código', value: 'id' },
    { text: 'Nome', value: 'physicalpeople.name' },
    { text: 'Ações', value: 'actions' }
];

export { headers };